import 'babel-core/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import { ReduxRouter } from 'redux-router';


import { browserHistory } from 'react-router'

import configureStore from '../common/store/configureStore';
import routes from '../common/routes';
import accountRoutes from '../common/account_routes';

import "../../styles/index.css";
import http from 'http';

const initialState = window.__INITIAL_STATE__;
const store = configureStore(initialState);
const rootElement = document.getElementById('root');


    let state = store.getState(),
        lang = state.user.lang,
        GAKeys = {
            'ru': 'UA-2733150-6',
            'en': 'UA-2733150-1',
            'fr': 'UA-2733150-5'
        };

    ReactGA.initialize(GAKeys[lang]);


function logPageView() {
    // if (window.location.pathname == '/map' && !window.location.search) {
    setTimeout(function(){
            ReactGA.set({page: window.location.pathname + window.location.search});
            ReactGA.pageview(window.location.pathname + window.location.search);
        }, 200
    );
    //  }

    window.scrollTo(0, 0);
}

ReactDOM.render(
  <Provider store={store}>
          <Router onUpdate={logPageView} children={(initialState.user.account)?accountRoutes:routes} history={browserHistory} />
  </Provider>,
  document.getElementById('root')
);

if (process.env.NODE_ENV !== 'production') {
  require('../server/devtools')(store);
}


// WEBPACK FOOTER //
// ./src/client/index.js